import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-07ec6f8f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "wd-count-rate-table" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "風向頻度", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "%", -1))

import { computed } from 'vue'
import { WIND_DIRECTION_LABELS } from '@/lib/constants'

type WdCountRateTableProps = {
  directions: number[]
}


export default /*#__PURE__*/_defineComponent({
  props: {
    directions: null
  },
  setup(__props: any) {

const props = __props as {
  directions: number[]
}



const headers = computed(() => {
  return Object.values(WIND_DIRECTION_LABELS)
})

const ratios = computed(() => {
  return Object.keys(WIND_DIRECTION_LABELS).map(_index => {
    const index = Number(_index)
    const value = props.directions[index]

    if (value === undefined) {
      return ''
    }

    return (value * 100).toFixed(1)
  })
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("table", null, [
      _createElementVNode("thead", null, [
        _createElementVNode("tr", null, [
          _hoisted_2,
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(headers), (header, index) => {
            return (_openBlock(), _createElementBlock("th", { key: index }, _toDisplayString(header), 1))
          }), 128))
        ])
      ]),
      _createElementVNode("tbody", null, [
        _createElementVNode("tr", null, [
          _hoisted_3,
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(ratios), (ratio, index) => {
            return (_openBlock(), _createElementBlock("td", { key: index }, _toDisplayString(ratio), 1))
          }), 128))
        ])
      ])
    ])
  ]))
}
}

})